var _a;
export var SchemaElementTypes;
(function (SchemaElementTypes) {
    SchemaElementTypes["STRING_TYPE"] = "stringType";
    SchemaElementTypes["INTEGER_TYPE"] = "integerType";
    SchemaElementTypes["FLOAT_TYPE"] = "floatType";
    SchemaElementTypes["BOOLEAN_TYPE"] = "booleanType";
    SchemaElementTypes["COMPOSITE_FIELD_TYPE"] = "compositeFieldType";
    SchemaElementTypes["CONDITIONAL_TYPE"] = "conditionalType";
    SchemaElementTypes["SPAN_TYPE"] = "spanType";
    SchemaElementTypes["EDITOR_TYPE"] = "editorType";
    SchemaElementTypes["DECORATION_TYPE"] = "decorationType";
    SchemaElementTypes["SEGMENT_TYPE"] = "segmentType";
    SchemaElementTypes["RELATION_TYPE"] = "relationType";
    SchemaElementTypes["RANGE_TYPE"] = "rangeType";
    SchemaElementTypes["GEOMETRY_TYPE"] = "geometryType";
    SchemaElementTypes["GEOMETRY_RANGE_TYPE"] = "geometryRangeType";
    SchemaElementTypes["TIMEPOINT_TYPE"] = "timePointType";
    SchemaElementTypes["TIMESTAMP_TYPE"] = "timestampType";
    SchemaElementTypes["FRAGMENT_TYPE"] = "fragmentType";
    SchemaElementTypes["TIMESTAMPED_GEOMETRY_RANGE_TYPE"] = "timestampedGeometryRangeType";
})(SchemaElementTypes || (SchemaElementTypes = {}));
export var schemaElementTypes = [
    SchemaElementTypes.STRING_TYPE,
    SchemaElementTypes.INTEGER_TYPE,
    SchemaElementTypes.FLOAT_TYPE,
    SchemaElementTypes.BOOLEAN_TYPE,
    SchemaElementTypes.COMPOSITE_FIELD_TYPE,
    SchemaElementTypes.CONDITIONAL_TYPE,
    SchemaElementTypes.SPAN_TYPE,
    SchemaElementTypes.EDITOR_TYPE,
    SchemaElementTypes.DECORATION_TYPE,
    SchemaElementTypes.SEGMENT_TYPE,
    SchemaElementTypes.RELATION_TYPE,
    SchemaElementTypes.RANGE_TYPE,
    SchemaElementTypes.GEOMETRY_TYPE,
    SchemaElementTypes.GEOMETRY_RANGE_TYPE,
    SchemaElementTypes.TIMEPOINT_TYPE,
    SchemaElementTypes.TIMESTAMP_TYPE,
    SchemaElementTypes.FRAGMENT_TYPE,
    SchemaElementTypes.TIMESTAMPED_GEOMETRY_RANGE_TYPE,
];
export var UIElementType;
(function (UIElementType) {
    UIElementType[UIElementType["TEXTAREA"] = 0] = "TEXTAREA";
    UIElementType[UIElementType["COMBO"] = 1] = "COMBO";
    UIElementType[UIElementType["TEXT"] = 2] = "TEXT";
    UIElementType[UIElementType["URL"] = 3] = "URL";
    UIElementType[UIElementType["INT"] = 4] = "INT";
    UIElementType[UIElementType["FLOAT"] = 5] = "FLOAT";
    UIElementType[UIElementType["CHECKBOX"] = 6] = "CHECKBOX";
    UIElementType[UIElementType["MULTISELECT"] = 7] = "MULTISELECT";
    UIElementType[UIElementType["COMPOSITE"] = 8] = "COMPOSITE";
    UIElementType[UIElementType["CONDITIONAL"] = 9] = "CONDITIONAL";
    UIElementType[UIElementType["UNSUPPORTED"] = 10] = "UNSUPPORTED";
    UIElementType[UIElementType["SPAN"] = 11] = "SPAN";
    UIElementType[UIElementType["EDITOR"] = 12] = "EDITOR";
    UIElementType[UIElementType["DECORATION"] = 13] = "DECORATION";
    UIElementType[UIElementType["RADIO"] = 14] = "RADIO";
    UIElementType[UIElementType["SEGMENT"] = 15] = "SEGMENT";
    UIElementType[UIElementType["RELATION"] = 16] = "RELATION";
    UIElementType[UIElementType["RANGE"] = 17] = "RANGE";
    UIElementType[UIElementType["GEOMETRY"] = 18] = "GEOMETRY";
    UIElementType[UIElementType["GEOMETRY_RANGE"] = 19] = "GEOMETRY_RANGE";
    UIElementType[UIElementType["TIMEPOINT"] = 20] = "TIMEPOINT";
    UIElementType[UIElementType["LITERAL"] = 21] = "LITERAL";
    UIElementType[UIElementType["TIMESTAMP"] = 22] = "TIMESTAMP";
    UIElementType[UIElementType["FRAGMENT"] = 23] = "FRAGMENT";
    UIElementType[UIElementType["TIMESTAMPED_GEOMETRY_RANGE"] = 24] = "TIMESTAMPED_GEOMETRY_RANGE";
    UIElementType[UIElementType["SLIDER"] = 25] = "SLIDER";
})(UIElementType || (UIElementType = {}));
export var PresentationElementType;
(function (PresentationElementType) {
    PresentationElementType[PresentationElementType["CONTAINER"] = 0] = "CONTAINER";
    PresentationElementType[PresentationElementType["REPEATABLE_ACTIONS"] = 1] = "REPEATABLE_ACTIONS";
})(PresentationElementType || (PresentationElementType = {}));
export var schemaToUiTypeMap = (_a = {},
    _a[SchemaElementTypes.STRING_TYPE] = UIElementType.TEXT,
    _a[SchemaElementTypes.INTEGER_TYPE] = UIElementType.INT,
    _a[SchemaElementTypes.FLOAT_TYPE] = UIElementType.FLOAT,
    _a[SchemaElementTypes.BOOLEAN_TYPE] = UIElementType.CHECKBOX,
    _a[SchemaElementTypes.COMPOSITE_FIELD_TYPE] = UIElementType.COMPOSITE,
    _a[SchemaElementTypes.CONDITIONAL_TYPE] = UIElementType.CONDITIONAL,
    _a[SchemaElementTypes.SPAN_TYPE] = UIElementType.SPAN,
    _a[SchemaElementTypes.EDITOR_TYPE] = UIElementType.EDITOR,
    _a[SchemaElementTypes.DECORATION_TYPE] = UIElementType.DECORATION,
    _a[SchemaElementTypes.SEGMENT_TYPE] = UIElementType.SEGMENT,
    _a[SchemaElementTypes.RELATION_TYPE] = UIElementType.RELATION,
    _a[SchemaElementTypes.RANGE_TYPE] = UIElementType.RANGE,
    _a[SchemaElementTypes.GEOMETRY_TYPE] = UIElementType.GEOMETRY,
    _a[SchemaElementTypes.GEOMETRY_RANGE_TYPE] = UIElementType.GEOMETRY_RANGE,
    _a[SchemaElementTypes.TIMEPOINT_TYPE] = UIElementType.TIMEPOINT,
    _a[SchemaElementTypes.TIMESTAMP_TYPE] = UIElementType.TIMESTAMP,
    _a[SchemaElementTypes.FRAGMENT_TYPE] = UIElementType.FRAGMENT,
    _a[SchemaElementTypes.TIMESTAMPED_GEOMETRY_RANGE_TYPE] = UIElementType.TIMESTAMPED_GEOMETRY_RANGE,
    _a);
export var configElementBaseTypes = [
    SchemaElementTypes.STRING_TYPE,
    SchemaElementTypes.INTEGER_TYPE,
    SchemaElementTypes.FLOAT_TYPE,
    SchemaElementTypes.BOOLEAN_TYPE,
    SchemaElementTypes.TIMEPOINT_TYPE,
    SchemaElementTypes.GEOMETRY_TYPE,
];
export var NumberType;
(function (NumberType) {
    NumberType[NumberType["INTEGER"] = 0] = "INTEGER";
    NumberType[NumberType["FLOAT"] = 1] = "FLOAT";
})(NumberType || (NumberType = {}));
export var ValidationLevel;
(function (ValidationLevel) {
    ValidationLevel[ValidationLevel["FIELD"] = 0] = "FIELD";
    ValidationLevel[ValidationLevel["FORM"] = 1] = "FORM";
})(ValidationLevel || (ValidationLevel = {}));
export var ElementsValuesType;
(function (ElementsValuesType) {
    ElementsValuesType[ElementsValuesType["TASK"] = 0] = "TASK";
    ElementsValuesType[ElementsValuesType["JOB"] = 1] = "JOB";
})(ElementsValuesType || (ElementsValuesType = {}));
export var CompositeNavigation;
(function (CompositeNavigation) {
    CompositeNavigation["GLOBAL"] = "GLOBAL";
    CompositeNavigation["TAB_PANEL"] = "TAB_PANEL";
    CompositeNavigation["TAB_SCROLL"] = "TAB_SCROLL";
})(CompositeNavigation || (CompositeNavigation = {}));
export var CompositeLayout;
(function (CompositeLayout) {
    CompositeLayout["CHAPTER"] = "CHAPTER";
    CompositeLayout["SECTION"] = "SECTION";
    CompositeLayout["QUESTIONNAIRE_BLOCK"] = "QUESTIONNAIRE_BLOCK";
    CompositeLayout["PROMPT_BLOCK"] = "PROMPT_BLOCK";
    CompositeLayout["DICTATION_BLOCK"] = "DICTATION_BLOCK";
    CompositeLayout["QUESTIONNAIRE_ITEM"] = "QUESTIONNAIRE_ITEM";
    CompositeLayout["PROMPT_HEADER_ITEM"] = "PROMPT_HEADER_ITEM";
    CompositeLayout["PROMPT_VALUE_ITEM"] = "PROMPT_VALUE_ITEM";
    CompositeLayout["DICTATION_HEADER_ITEM"] = "DICTATION_HEADER_ITEM";
    CompositeLayout["DICTATION_VALUE_ITEM"] = "DICTATION_VALUE_ITEM";
})(CompositeLayout || (CompositeLayout = {}));
export var ComparisonReferences;
(function (ComparisonReferences) {
    ComparisonReferences["EQ"] = "eqReferences";
    ComparisonReferences["GT"] = "gtReferences";
    ComparisonReferences["GTE"] = "gteReferences";
    ComparisonReferences["LT"] = "ltReferences";
    ComparisonReferences["LTE"] = "lteReferences";
})(ComparisonReferences || (ComparisonReferences = {}));
